// Modules
import React, { useState, useEffect }       from 'react'
import TextArea                  from '@shared/textarea'
import { postRequest, pathname } from "@react/helpers/fetch"
import consumer from 'channels/consumer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CHANNEL = "ChatGptChannel"

const AiTextArea = ({ name, value, path, channel }) => {
  const [state, setState] = useState({ text: value, loading: false })

  const received = data => {
    if (state.subscription) state.subscription.unsubscribe()

    setState({ text: data.text, loading: false })
  }

  const improve = () => {
    if (state.loading || !state.text) return

    const format = "json"
    const url = pathname({ path, format })
    const body = { text: state.text }
    const subscription = consumer.subscriptions.create(channel, { received })
    setState(prevState => ({ ...prevState, subscription, loading: true }))
    postRequest({ url, body })
  }

  useEffect(() => {
    return () => {
      if (state.subscription) {
        state.subscription.unsubscribe()
      }
    }
  }, [state.subscription])

  return (
    <>
      <TextArea
        onChange      = {text => setState((prevState) => ({ ...prevState, text })) }
        defaultValue  = {state.text || ''}
        name          = {name}
      />

      <div className="text-right text-pointer mt-1 small" onClick={improve}>
        <FontAwesomeIcon icon={state.loading ? "spinner" : "magic" } spin={state.loading} className="mr-1" />
        { I18n.t("button.improve_with_ai") }
      </div>
    </>
  )
}

export default AiTextArea


